import { Components } from '@mui/material';
import { Theme } from '@mui/system';
import { fontFamily } from './typography';

export const buildMuiMenuComponent = (): Components<Omit<Theme, 'components'>>['MuiMenu'] => ({
  styleOverrides: {
    list: {
      padding: 0,
    },
  },
});

export const buildMuiMenuItemComponent = (): Components<Omit<Theme, 'components'>>['MuiMenuItem'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '150%',
      margin: '10px',
      height: '44px',
      color: theme.palette.primary[80],
      padding: '10px',
      outline: 0,
      borderRadius: '4px',
      '&.Mui-selected, &.Mui-selected.Mui-focusVisible, &.Mui-selected:hover': {
        backgroundColor: theme.palette.secondary[30],
      },
      '&:hover, &.Mui-focusVisible': {
        backgroundColor: theme.palette.secondary[10],
      },
    }),
  },
});
